<script>
    import jQuery from "jquery";
    import {getGPTransFunc} from "./gp-translations.js";
    let trans = getGPTransFunc("gp-areyousurewarning");
    let resolve;
    let reject;
    export let message;
    export let confirmMode = true;
    export let title = confirmMode ? trans("You're sure?") : "&nbsp;";
    let confirmText = confirmMode ? trans("Yes") : trans("OK")

    export function open() {
        jQuery('#GPAreYouSureWarning').modal({});
        jQuery('#GPAreYouSureWarning').on('hidden.bs.modal', () => this.$destroy());

        //trap focus
        jQuery('#GPAreYouSureWarning').on('shown.bs.modal',function (){jQuery('#GPAreYouSureDismiss').focus();});
        jQuery('#GPAreYouSureWarning .close').on('keydown', function(e) {if (e.shiftKey && e.which===9) e.preventDefault();});
        jQuery('#GPAreYouSureConfirm').on('keydown', function(e) {if (!e.shiftKey && e.which===9) e.preventDefault();});

        return new Promise((res, rej) => {
            resolve = res;
            reject = rej
        })
    }
       

</script>

<div class="modal fade GPModal" id="GPAreYouSureWarning">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title">{@html title}</h4>
            </div>
            {#if message}
            <div class="modal-body">
                <p>{@html message}</p>
            </div>
            {/if}
            <div class="modal-footer">
                {#if confirmMode}
                <button on:click={reject} id="GPAreYouSureDismiss" type="button" class="btn btn-default" data-dismiss="modal">{trans("Cancel")}</button>
                {/if}
                <button on:click={resolve} id="GPAreYouSureConfirm" type="button" class="btn btn-primary" data-dismiss="modal">{confirmText}</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->        